import React from 'react';

const BrandsSection = () => {
  // Brand logos list - 20 brands with custom scales
  const brands = [
    { name: 'Ebebek', logo: '/brands/ebebek.png', scale: 1 },
    { name: 'Pastel', logo: '/brands/pastel.png', scale: 1 },
    { name: 'Braun', logo: '/brands/braun.png', scale: 1 },
    { name: 'Tecno Mobile', logo: '/brands/tecno.png', scale: 1, whiteBackground: true },
    { name: 'Shevec', logo: '/brands/shevec.png', scale: 1 },
    { name: 'Macrocenter', logo: '/brands/macrocenter.png', scale: 1 },
    { name: 'Prozinc', logo: '/brands/prozinc.png', scale: 1 },
    { name: 'Oksizinc', logo: '/brands/oksizinc.png', scale: 1 },
    { name: 'Dermotek', logo: '/brands/dermotek.png', scale: 1 },
    { name: 'ROCS', logo: '/brands/rocs.png', scale: 1 },
    { name: 'The Ceel', logo: '/brands/the-ceel.png', scale: 1 },
    { name: 'NTT DATA', logo: '/brands/ntt-data.jpg', scale: 1 },
    { name: 'Tiefenbacher Pharmaceuticals', logo: '/brands/tiefenbacher.png', scale: 1 },
    { name: 'ACE Gallagher', logo: '/brands/ace-gallagher.png', scale: 1 },
    { name: 'Turkish Business Council Dubai', logo: '/brands/turkish-business-council.png', scale: 1 }, // Moved here (after ACE)
    { name: 'Vanity', logo: '/brands/vanity.png', scale: 1 },
    { name: 'Nova IT Academy', logo: '/brands/nova-it-academy.png', scale: 1 },
    { name: 'CSS Co', logo: '/brands/css.png', scale: 1 },
    { name: 'Vestiti', logo: '/brands/vestiti.png', scale: 1 },
    { name: 'Sterilisa', logo: '/brands/sterilisa.png', scale: 1 }, // Back to 1x, new logo (.png), moved to end
  ];

  return (
    <section className="py-8 bg-white relative overflow-hidden">
      {/* Background decoration - adjusted for white background */}
      <div className="absolute inset-0 opacity-3 pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-[#FFDD59] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#FFDD59] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Brands Grid - 5 logos per row with normalized sizes */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 items-center">
          {brands.map((brand, index) => (
            <div
              key={index}
              className={`flex items-center justify-center p-6 rounded-lg hover:bg-gray-50 transition-all duration-300 hover:scale-105 border border-gray-200 shadow-sm ${
                brand.whiteBackground ? 'bg-white' : 'bg-white'
              }`}
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="w-full object-contain transition-all"
                style={{
                  height: `${3 * (brand.scale || 1)}rem` // Base 3rem (48px), multiply by scale
                }}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
